import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Slider from 'components/atoms/Sliders/Slider/Slider';

const StyledScrollSlider = styled(Slider)`
  &:not(.ScrollSlider-visible) {
    display: none;
  }

  &.ScrollSlider-scrolled {
    .MuiSlider-thumb {
      transition-property: box-shadow;
    }

    .MuiSlider-track {
      transition: none;
    }
  }

  ${ComponentStyles}
`;

StyledScrollSlider.propTypes = {
  theme: PropTypes.object
};

export default StyledScrollSlider;
